// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"c42998bc","268":"93d9a45d","282":"5df68851","321":"d20c2d79","397":"232ca424","538":"f2ea68f7","563":"b0e7101d","668":"120d7f52","780":"db19ec44","787":"86964e13","915":"3185fe4e","968":"e142fbc1"}[chunkId] + ".chunk.js";
};